import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TokenProvider } from "./TokenContext";
import { ConfigProvider } from "./utils/ConfigContext";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <TokenProvider>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </TokenProvider>
  </React.StrictMode>
);
reportWebVitals();
